import { Center } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { useCallback, useEffect, useState } from "react";

const MotionCenter = motion(Center);

const SCROLL_THRESHOLD = 400;

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const getScrollTarget = useCallback(() => {
    return document.getElementById("main-content-area") || window;
  }, []);

  const getScrollTop = useCallback(() => {
    const target = getScrollTarget();
    if (target instanceof HTMLElement) return target.scrollTop;
    return window.scrollY;
  }, [getScrollTarget]);

  useEffect(() => {
    const target = getScrollTarget();
    const handleScroll = () => setVisible(getScrollTop() > SCROLL_THRESHOLD);
    target.addEventListener("scroll", handleScroll, { passive: true });
    return () => target.removeEventListener("scroll", handleScroll);
  }, [getScrollTarget, getScrollTop]);

  const scrollToTop = () => {
    const target = getScrollTarget();
    if (target instanceof HTMLElement) {
      target.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <MotionCenter
          as="button"
          type="button"
          aria-label="Back to top"
          onClick={scrollToTop}
          position="fixed"
          bottom={{ base: "calc(140px + env(safe-area-inset-bottom))", md: "90px" }}
          right={{ base: "16px", md: "24px" }}
          w="40px"
          h="40px"
          borderRadius="50%"
          bg="white"
          color="neutral.600"
          boxShadow="0 2px 8px 0 rgba(0,0,0,0.15), 0 1px 3px 0 rgba(0,0,0,0.1)"
          cursor="pointer"
          zIndex={1400}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          _hover={{
            bg: "neutral.50",
            boxShadow: "0 4px 12px 0 rgba(0,0,0,0.2), 0 2px 4px 0 rgba(0,0,0,0.12)",
            transform: "translateY(-1px)",
          }}
          _active={{
            transform: "scale(0.95)",
          }}
        >
          <ArrowUp size={18} strokeWidth={2.5} />
        </MotionCenter>
      )}
    </AnimatePresence>
  );
};

export default BackToTopButton;
